import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { LegalFees } from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface SetLegalFeesAmountRequest {
    engagementId: number;
    amountOwedAtClose: number | null;
}

export const SetLegalFeesAmount = createAsyncThunk(
    'flowOfFunds/setLegalFeesAmount',
    async (params: SetLegalFeesAmountRequest, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.put(
                `/api/flowOfFunds/${params.engagementId}/legalFees`,
                {
                    amountOwedAtClose: params.amountOwedAtClose,
                }
            );

            if (response.status !== 200) {
                throw new Error('Failed to save the legal fees amount');
            }

            return response.data as LegalFees;
        } catch (error) {
            createNotification('Could not save the legal fees amount.', 'error');
            throw error;
        }
    }
);
